<template>
  <div class="hero-container">
    <img v-lazy="imagePaths.mobile" class="d-block d-sm-none" :alt="altText" />
    <img v-lazy="imagePaths.desktop" class="d-none d-sm-block" :alt="altText" />
    <div class="opacity"></div>
    <div class="container">
      <div class="row justify-content-center justify-content-md-start">
        <div class="col-10 col-md-8 col-xl-5 text-center text-md-left">
          <slot name="content"></slot>
          <router-link to="/get-start?step=1" tag="button" class="cta"
            >Get a quote</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imageName", "altText", "ctaButtonTitle"],
  computed: {
    imagePaths: function () {
      const mainDir = "/static/assets/imgs/";
      return {
        mobile: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}-mobile${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
        desktop: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-container {
  padding-top: 40px;
  padding-bottom: 40px;
  position: relative;

  @media (min-width: 768px) {
    padding-top: 60px;
    padding-bottom: 55px;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: -2;
    object-position: center;
  }

  .opacity {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(51, 51, 51, 0.5);
  }

  color: #ffffff;
}

.container {
  @media (min-width: 768px) {
    padding-left: 60px;
    padding-right: 60px;
  }

  @media (min-width: 1200px) {
    padding-left: 120px;
    padding-right: 120px;
  }
}

h1 {
  font-size: 30px !important;
  font-weight: 900;
  margin: 0;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 55px !important;
  }
}

p {
  margin-bottom: 0;
  font-size: 18px;
}

button {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// HeroFull.vue?4e39f606